export const useModalityFilter = defineStore('modalityFilter', {
  state: (): {
    modules_codenames: string[]
  } => ({
    modules_codenames: []
  }),
  actions: {
    set(codenames: string[]) {
      this.modules_codenames = codenames
    }
  },
  getters: {
    get: (state) => (): string[] => {
      return state.modules_codenames
    }
  }
})
